import { render } from "./KBLI.vue?vue&type=template&id=39735396"
import script from "./KBLI.vue?vue&type=script&lang=js"
export * from "./KBLI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__